var _a;
export var StitchClientErrorCode;
(function (StitchClientErrorCode) {
    StitchClientErrorCode[StitchClientErrorCode["LoggedOutDuringRequest"] = 0] = "LoggedOutDuringRequest";
    StitchClientErrorCode[StitchClientErrorCode["MustAuthenticateFirst"] = 1] = "MustAuthenticateFirst";
    StitchClientErrorCode[StitchClientErrorCode["UserNoLongerValid"] = 2] = "UserNoLongerValid";
    StitchClientErrorCode[StitchClientErrorCode["CouldNotLoadPersistedAuthInfo"] = 3] = "CouldNotLoadPersistedAuthInfo";
    StitchClientErrorCode[StitchClientErrorCode["CouldNotPersistAuthInfo"] = 4] = "CouldNotPersistAuthInfo";
    StitchClientErrorCode[StitchClientErrorCode["StreamingNotSupported"] = 5] = "StreamingNotSupported";
    StitchClientErrorCode[StitchClientErrorCode["StreamClosed"] = 6] = "StreamClosed";
})(StitchClientErrorCode || (StitchClientErrorCode = {}));
export var clientErrorCodeDescs = (_a = {},
    _a[StitchClientErrorCode.LoggedOutDuringRequest] = "logged out while making a request to Stitch",
    _a[StitchClientErrorCode.MustAuthenticateFirst] = "method called requires being authenticated",
    _a[StitchClientErrorCode.UserNoLongerValid] = "user instance being accessed is no longer valid; please get a new user with auth.getUser()",
    _a[StitchClientErrorCode.CouldNotLoadPersistedAuthInfo] = "failed to load stored auth information for Stitch",
    _a[StitchClientErrorCode.CouldNotPersistAuthInfo] = "failed to save auth information for Stitch",
    _a[StitchClientErrorCode.StreamingNotSupported] = "streaming not supported in this SDK",
    _a[StitchClientErrorCode.StreamClosed] = "stream is closed",
    _a);
//# sourceMappingURL=StitchClientErrorCode.js.map